/* AB-K1-11 — Complete your kit.
   De grit-selector (Replacement Whetstones 400/1000) is het <select name="id">
   in het product-form; product-form.js post de gekozen variant naar /cart/add
   en opent de cart drawer. Dit element houdt het theme-price-snippet van de
   kaart in sync met de gekozen variant (data-price / data-compare op de option)
   en zet de knop uit bij een uitverkochte variant. */
if (!customElements.get('complete-your-kit-card')) {
  customElements.define(
    'complete-your-kit-card',
    class CompleteYourKitCard extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-cyk-select]');
        if (!this.select) return;
        this.price = this.querySelector('.price');
        this.button = this.querySelector('[type="submit"]');
        this.select.addEventListener('change', () => this.sync());
        this.sync();
      }

      sync() {
        const option = this.select.selectedOptions[0];
        if (!option) return;
        if (this.price) {
          const compare = option.dataset.compare || '';
          const sale = this.price.querySelector('.price-item--sale');
          const regular = this.price.querySelector('.price-item--regular');
          if (compare && sale && regular) {
            sale.textContent = option.dataset.price || sale.textContent;
            regular.textContent = compare;
            this.price.classList.add('price--on-sale');
          } else if (regular) {
            regular.textContent = option.dataset.price || regular.textContent;
            if (!compare) this.price.classList.remove('price--on-sale');
          }
        }
        if (this.button) {
          const soldOut = option.disabled;
          this.button.disabled = soldOut;
          this.button.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
        }
      }
    }
  );
}
